import React from 'react'
import { usePrismicDocumentsByUIDs } from '@prismicio/react'

import { RelatedBlog } from "./RelatedBlog";

export const RelatedBlogFetch = ({ data, value }) => {
	const [documents, { state }] = usePrismicDocumentsByUIDs('category', data)

	return state !== 'loaded'
		? null
		: <RelatedBlog data={documents} value={value} />
};

